module.exports = __webpack_public_path__ + "img/roofScrews.f2ad727e.jpg";